import type { UserResponse } from '@shared/schemas';

import {
  type AdminDraft,
  emptyDraft,
  type LoadStatus,
  type SaveStatus,
  type ValidationErrors,
} from '../../_shared/domain/administrator-draft.model';
import type { EditAdministratorError } from '../domain/edit-administrator-error';

/**
 * Redux state for the Edit-administrator form. Beyond the shared draft + save
 * lifecycle, Edit also tracks the loaded user (for archive gating + header),
 * the load lifecycle, and an independent archive lifecycle. Every field is
 * serialisable.
 */
export interface EditAdministratorState {
  /** The admin being edited (null until loaded / when not found). */
  user: UserResponse | null;
  draft: AdminDraft;
  loadStatus: LoadStatus;
  saveStatus: SaveStatus;
  archiveStatus: SaveStatus;
  validationErrors: ValidationErrors;
  error: EditAdministratorError | null;
}

export const initialState: EditAdministratorState = {
  user: null,
  draft: emptyDraft,
  loadStatus: 'idle',
  saveStatus: 'idle',
  archiveStatus: 'idle',
  validationErrors: {},
  error: null,
};
